module.exports = __webpack_public_path__ + "static/Scroll Group 1@2x-4fdbfe5a7fd75be30bf5ea91c84d8937.png";